import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { environment } from '../../environments/environment';
// import { ApiService } from 'app/api.service';
import { LoaderService } from 'app/loader.service';
// import { HubService } from 'app/hub.service';
// import { ChartsService } from 'app/charts.service';

@Component({
  selector: 'app-app-store-link',
  templateUrl: './app-store-link.component.html',
  styleUrls: ['./app-store-link.component.scss']
})
export class AppStoreLinkComponent implements OnInit {

  // Define some public variables
  urlWorkoutId: "";
  urlWorkoutTitle: "";
  workout: object = {};
  profileChartOptions: any;
  // zoneChartOptions: any;

  constructor(
    private route: ActivatedRoute,
    private loaderService: LoaderService,

  ) { }

  ngOnInit() {
    this.loaderService.setLoaded();
    
    
  }


}



// WEBPACK FOOTER //
// /tmp/build_769bc651/src/app/app-store-link/app-store-link.component.ts